module.exports = __webpack_public_path__ + "static/media/control-gris.31133236.svg";